// Persists the in-flight email-MFA challenge so a browser refresh on the code
// screen resumes there instead of dropping back to the password step. The
// `mfaToken` is an opaque, short-lived challenge handle (not a session) — we
// keep it in sessionStorage so it dies with the tab. The session JWT itself is
// never stored here (see AuthToken).
const KEY = 'oceanAdminMfaChallenge';

export const MfaChallengeStorage = {
  get() {
    try {
      const raw = sessionStorage.getItem(KEY);
      if (!raw) {
        return null;
      }

      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.mfaToken) {
        return null;
      }

      // Drop an already-expired challenge so we don't show a dead code screen.
      if (
        parsed.expiresAt &&
        new Date(parsed.expiresAt).getTime() <= Date.now()
      ) {
        this.clear();
        return null;
      }

      return parsed;
    } catch (error) {
      return null;
    }
  },

  save({
    mfaToken,
    maskedEmail,
    expiresAt,
    resendCooldownUntil,
  }) {
    try {
      sessionStorage.setItem(
        KEY,
        JSON.stringify({
          mfaToken,
          maskedEmail,
          expiresAt,
          resendCooldownUntil,
        }),
      );
    } catch (error) {
      // sessionStorage may be unavailable (private mode / disabled) — the flow
      // still works in-memory, it just won't survive a refresh.
    }
  },

  update(patch) {
    const current = this.get();
    if (!current) {
      return;
    }
    this.save({ ...current, ...patch });
  },

  clear() {
    try {
      sessionStorage.removeItem(KEY);
    } catch (error) {
      // ignore
    }
  },
};

export default MfaChallengeStorage;
